import { ApiService } from './../../services/api.service';
import { APIs } from './../../config/api.constant';
import { AppStateProvider } from './../../services/app-state.provider';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  @Input() isFeedback;
  isLoggedIn: boolean = false;
  public dynamicYear: any;
  contactDetails: {
    call: string;
    email: string;
    address: {
      buildingName: string;
      area: string;
      city: string;
      pinCode: string;
    };
  } = {
      call: '',
      email: '',
      address: { buildingName: '', area: '', city: '', pinCode: '' },
    };

  constructor(
    private appStateSrv: AppStateProvider,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.appStateSrv.getLoginStatus().subscribe((status) => {
      this.isLoggedIn = status;
    });
    // console.log("this.isFeedback", this.isFeedback, this.isLoggedIn)

    // this.fetchContactDetails();
    this.dynamicYear = new Date().getFullYear();
  }

  fetchContactDetails() {
    const url = APIs.getContactsData;

    this.apiService.get(url, '').subscribe(
      (response: any) => {
        this.contactDetails.call = response.data.contactNumber;
        this.contactDetails.email = response.data.emailId;
        this.contactDetails.address.buildingName = response.data.buildingName;
        this.contactDetails.address.area = response.data.area;
        this.contactDetails.address.city = response.data.city;
        this.contactDetails.address.pinCode = response.data.pincode;
        // console.log('contact', this.contactDetails);
      },
      (err) => console.log('error', err)
    );
  }
}
